import React from 'react';

import { Icon } from '../icons';

export const UploadIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 20 20" fill={color} style={style}>
      <g>
        <path d="M16.0681 15.8348L3.93194 15.8348C3.45155 15.8348 3.06507 16.2213 3.06507 16.7017L3.06507 17.5686C3.06507 18.0489 3.45155 18.4354 3.93194 18.4354L16.0681 18.4354C16.5485 18.4354 16.9349 18.0489 16.9349 17.5686L16.9349 16.7017C16.9349 16.2213 16.5485 15.8348 16.0681 15.8348Z" />
        <path d="M6.32846 8.55192L8.69789 6.18249L8.69789 13.7351C8.69789 14.2155 9.08437 14.6019 9.56476 14.6019L10.4316 14.6019C10.912 14.6019 11.2985 14.2155 11.2985 13.7351L11.2985 6.18249L13.6679 8.55192C14.0074 8.89145 14.5565 8.89145 14.8924 8.55192L15.5064 7.93789C15.8459 7.59837 15.8459 7.04936 15.5064 6.71344L10.6122 1.81926C10.2727 1.47974 9.72368 1.47974 9.38777 1.81926L4.49359 6.71345C4.15407 7.05297 4.15407 7.60198 4.49359 7.93789L5.10762 8.55192C5.44353 8.89145 5.99255 8.89145 6.32846 8.55192Z" />
      </g>
    </svg>
  );
};
